//Components
import { EventTableWithRubrics } from '../../components/event';
import { PageHeader } from '../../components/shared';
import Box from '@mui/material/Box';

export const EventPage = () => {
  return (
    <Box sx={{ minHeight: '100vh', p: { xs: 1.5, sm: '2%' }, background: '#f4f1e9' }}>
      <PageHeader title="Eventos" />
      <EventTableWithRubrics />
    </Box>
  );
};
